import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class PollProps {
  @Inlet(Accepts.Image) public headerImage?: Types["Image"];
  @Inlet(Accepts.MarkdownText) public text?: Types["MarkdownText"];
  @Inlet(Accepts.Number) public scale?: number;
  @Inlet(Accepts.PollType) public pollType?: Types["PollType"];
  @Inlet(Accepts.PollList) public polls?: Types["PollList"];

  @Inlet(Accepts.PollResultList) public pollResults?: Types["PollResultList"];
}

export const PollDefinition = defineElement("poll", PollProps, {
  versionRequired: "0.9.0",
});
